import React, { useEffect, useRef } from 'react';
interface CheckboxProps {
  indeterminate?: boolean;
  [key: string]: any;
}

export const Checkbox = React.forwardRef(({ indeterminate, ...rest }: CheckboxProps, ref: React.Ref<HTMLInputElement> | null) => {
  const defaultRef = useRef<HTMLInputElement>(null);
  const resolvedRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    resolvedRef.current = ref ? (ref as React.MutableRefObject<HTMLInputElement | null>).current : defaultRef.current;
    if (resolvedRef.current) {
      resolvedRef.current.indeterminate = indeterminate || false;
    }
  }, [resolvedRef, ref, indeterminate]);

  return (
    <>
      <label className='custom-checkbox'>
        <input type='checkbox' ref={resolvedRef} {...rest} />

        <span className='checkmark'></span>
      </label>
    </>
  );
});
